/* Export helpers for the Analytics page — no external dependency.
 * CSV opens anywhere; the .xls (HTML workbook) opens directly in Excel. */

const cell = (v) => (v === null || v === undefined ? "" : String(v));

const csvCell = (v) => {
  const s = cell(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

/** columns: [{ key, label }], rows: array of objects */
export const exportTableCSV = (filename, columns, rows) => {
  const header = columns.map((c) => csvCell(c.label)).join(",");
  const body = rows
    .map((r) => columns.map((c) => csvCell(r[c.key])).join(","))
    .join("\n");
  const csv = "﻿" + header + "\n" + body; // BOM for Excel
  download(csv, `${filename}.csv`, "text/csv;charset=utf-8;");
};

const tableHtml = (title, columns, rows) => {
  const head = columns
    .map(
      (c) =>
        `<th style="background:#F1F1FB;border:1px solid var(--app-border);padding:6px 10px;font-weight:700;text-align:left">${cell(
          c.label,
        )}</th>`,
    )
    .join("");
  const body = rows
    .map(
      (r) =>
        `<tr>${columns
          .map(
            (c) =>
              `<td style="border:1px solid var(--app-border);padding:6px 10px">${cell(
                r[c.key],
              )}</td>`,
          )
          .join("")}</tr>`,
    )
    .join("");
  const caption = title
    ? `<tr><td colspan="${columns.length}" style="background:#5751E9;color:#fff;font-weight:700;padding:8px 10px">${title}</td></tr>`
    : "";
  return `<table>${caption}<thead><tr>${head}</tr></thead><tbody>${body}</tbody></table>`;
};

/** Single table → Excel-openable .xls */
export const exportTableExcel = (filename, columns, rows, title = "") => {
  const html = wrapWorkbook(tableHtml(title, columns, rows));
  download(html, `${filename}.xls`, "application/vnd.ms-excel;charset=utf-8;");
};

/** Multiple sections → one .xls with each table stacked and labelled */
export const exportAllExcel = (filename, sections) => {
  const inner = sections
    .filter((s) => s && s.rows && s.rows.length)
    .map((s) => tableHtml(s.title, s.columns, s.rows))
    .join("<br/><br/>");
  download(
    wrapWorkbook(inner),
    `${filename}.xls`,
    "application/vnd.ms-excel;charset=utf-8;",
  );
};

const wrapWorkbook = (inner) =>
  `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"><head><meta charset="UTF-8"></head><body>${inner}</body></html>`;

const download = (content, name, type) => {
  const blob = new Blob([content], { type });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = name;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};
